<template>
    <div class="card card-m card-p-10">
        <div class="brand-image-section">
            <div class="brand-main-section">
                <a v-if="props.franchise" href="#" target="_blank">
                    <img :src="props.franchise.logo || 'https://via.placeholder.com/205x100?text=Franchise+Logo'"
                        :alt="props.franchise.name" 
                        class="franchise-logo"
                        loading="lazy"></a>
                <a v-else href="/brands/USPFC.14848" target="_blank">
                    <img src="https://via.placeholder.com/205x100?text=Franchise+Logo"
                        alt="US Pizza & Fried Chicken" 
                        class="franchise-logo"
                        loading="lazy"></a>
            </div>
        </div>
        <div class="card-body-section">
            <p>
                <span v-if="props.franchise">{{ props.franchise.category }}</span>
                <a v-else href="https://www.franchiseindia.com/business-opportunities/food-and-beverage.m2"
                    target="_blank">Food and Beverage</a>
            </p>
            <h2>
                <span v-if="props.franchise">{{ props.franchise.name }}</span>
                <a v-else href="/brands/USPFC.14848" target="_blank">US Pizza & Fried Chicken</a>
            </h2>
            <div class="d-flex">
                <div class="card-info">Investment</div>
                <div class="card-info-amt">
                    <span v-if="props.franchise">{{ formatInvestment(props.franchise.investment) }}</span>
                    <span v-else>₹10L - 20L</span>
                </div>
            </div>
            <div class="d-flex">
                <div class="card-info">Expected ROI (months)</div>
                <div class="card-info-amt">
                    <span v-if="props.franchise">{{ formatRoi(props.franchise.expectedRoi,
                        props.franchise.expectedRoiMax) }}</span>
                    <span v-else>18 - 24</span>
                </div>
            </div>
            <div class="d-flex">
                <div class="card-info">Franchise Outlets</div>
                <div class="card-info-amt">
                    <span v-if="props.franchise">{{ formatOutlets(props.franchise.outlets) }}</span>
                    <span v-else>10-20</span>
                </div>
            </div>
            <div class="link-section">
                <router-link v-if="props.franchise && props.franchise.id" 
                            :to="`/franchise/${props.franchise.id}`">
                    Know More
                </router-link>
                <a v-else href="/brands/USPFC.14848" target="_blank">Know More</a>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue'
import { formatInvestment, formatRoi, formatOutlets } from '@/utils/formatters'

const props = defineProps({
    franchise: {
        type: Object,
        default: null
    }
})
</script>
<style scoped>
/* Fixed logo sizing and centering */
.card .brand-image-section {
    overflow: hidden !important;
    position: relative !important;
    height: 128px !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: #fafafa !important;
    border: 1px solid #e5e5e5 !important;
    border-radius: 4px !important;
}

.card .brand-main-section {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    width: 100% !important;
    padding: 8px !important;
}

.card .brand-main-section a {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    text-decoration: none !important;
}

.card .brand-main-section a:hover {
    text-decoration: none !important;
}

.card .franchise-logo {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    display: block !important;
    margin: 0 auto !important;
    border-radius: 4px !important;
    max-width: none !important;
    max-height: none !important;
}

/* Fixed title text wrapping */
.card.card-m.card-p-10 {
  min-height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.card .card-body-section {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.card .card-body-section h2 {
  font-size: 14px !important;
  line-height: 1.4 !important;
  margin-top: 9px !important;
  margin-bottom: 9px !important;
  font-weight: 600 !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  min-height: auto !important;
  height: auto !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.card .card-body-section h2 span,
.card .card-body-section h2 a {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
    display: inline !important;
    text-decoration: none !important;
    color: inherit !important;
}

.card .card-body-section h2 a:hover {
    text-decoration: none !important;
    color: inherit !important;
}

/* Card info styling with orange accents */
.card .card-body-section p {
    color: #1e1e1e !important;
    font-weight: 600 !important;
    margin-bottom: 8px !important;
}

.card .card-body-section p a {
    color: #080808 !important;
    text-decoration: none !important;
}

.card .card-body-section p a:hover {
    color: #0b0a0a !important;
    text-decoration: underline !important;
}

/* Investment and ROI info styling */
.card .card-info {
    color: #181818 !important;
    font-weight: 500 !important;
}

.card .card-info-amt {
    color: #181818 !important;
    font-weight: 600 !important;
}

/* Link section styling */
.card .link-section {
    margin-top: auto !important;
}

.card .link-section a {
    color: #ff6b35 !important;
    text-decoration: none !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;
}

.card .link-section a:hover {
    color: #e55a2b !important;
    text-decoration: none !important;
}

.know-more-btn {
    color: #ff6b35 !important;
    text-decoration: none !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;
    background: none !important;
    border: none !important;
    cursor: pointer !important;
    font-size: inherit !important;
    font-family: inherit !important;
    padding: 0 !important;
}

.know-more-btn:hover {
    color: #e55a2b !important;
    text-decoration: none !important;
}



/* Responsive adjustments */
@media screen and (max-width: 768px) {
    .card .brand-image-section {
        height: 100px !important;
    }
    
    .card .brand-main-section {
        padding: 6px !important;
    }
    
    .card .card-body-section h2 {
        font-size: 13px !important;
        line-height: 1.3 !important;
    }
}

@media screen and (max-width: 480px) {
    .card .brand-image-section {
        height: 80px !important;
    }
    
    .card .brand-main-section {
        padding: 4px !important;
    }
    
    .card .card-body-section h2 {
        font-size: 12px !important;
        line-height: 1.2 !important;
    }
}
</style>